import { useCallback } from 'react';
import type { Attributes } from '@atlassian/jira-product-analytics-bridge';
import { isLoaderError } from '@atlassian/react-loosely-lazy';

export const addChunkLoadErrorAnalyticsAttribute = (error: Error): Attributes => ({
	chunkLoadError: isLoaderError(error),
});

export const useAddErrorBoundaryAnalyticsAttributes = (attributes: Attributes = {}) =>
	useCallback(
		(error: Error) => ({
			...attributes,
			...addChunkLoadErrorAnalyticsAttribute(error),
		}),
		[attributes],
	);
